import React, { FC } from 'react';

import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { font } from '@styles/fonts';
import { ColorFunction } from '@styles/colors/types';
import Svg from '@styles/icons/svg';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';
import { TimeCategory } from '@interfaces/base';
import svgRegister from '@styles/icons/svg/svgRegister';

export interface TimeBlockItemProps {
  timeBlockItem: { name: TimeCategory; key: string; color: string; timeValue: number; icon: keyof typeof svgRegister; width: number; height: number };
  C: ColorFunction;
}

const TimeBlockItem: FC<TimeBlockItemProps> = ({ timeBlockItem, C }) => {
  const { color, name, timeValue, icon, width, height } = timeBlockItem;
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingRight: scale(isPhone ? 0 : 15) }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(5) }}>
        <Svg icon={icon} width={scale(width)} height={scale(height)} color={color} />
        <Text style={[font['Subhead 2'], { color: C(color) }]}>{i18n.t(name)}</Text>
      </View>
      <TimeDisplayInStaticFormat {...{ color, C, timeValue }} />
    </View>
  );
};

export default TimeBlockItem;